import { render, staticRenderFns } from "./category-card.vue?vue&type=template&id=13691bdf&scoped=true"
import script from "./category-card.vue?vue&type=script&lang=js"
export * from "./category-card.vue?vue&type=script&lang=js"
import style0 from "./category-card.vue?vue&type=style&index=0&id=13691bdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13691bdf",
  null
  
)

export default component.exports